export const shouldRefreshButtonAppear = (message, user) => {
  return !!user.uuid && user.uuid === message.uuid;
};
